import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowIcon from "src/assets/icons/floor-plan/ArrowIcon";

const TableInventory = ({ isManagementSection, tablesInventory, customerAreasInventory, selectedArea, onAddTable, onAddButton }) => {

  if (selectedArea?.id !== "Entrance" && !tablesInventory[selectedArea?.id]) return null;

  const Item = ({ title, count, isTable, onClick }) => {
    return (
      <Box
        key={title}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#1e1e1e",
          borderRadius: 2,
          py: 1.5,
          px: 1.5,
          my: 0.75,
          width: "100%",
        }}
      >
        <Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1">{title}</Typography>
            {!isTable && <ArrowIcon/>}
          </Box>
          <Typography variant="subtitle2" color="#d1d1d6">
            {isTable ? count > 0 ? `${count} tables left` : "All tables added" : count > 0 ? "1 button left" : "All buttons added"}
          </Typography>
        </Box>
        <IconButton
          onClick={() => onClick()}
          disabled={count === 0}
          sx={{
            backgroundColor: "rgb(6,6,6,0.2)",
            borderRadius: 1,
            width: 40,
            height: 40,
            color: "white",
            "&:hover": {
              backgroundColor: "rgb(6,6,6,0.5)",
              color: "white",
            },
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
    )
  }

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto", mb: 1.5, px: 1 }}
    >
      {selectedArea?.id !== "Entrance" && Object.entries(tablesInventory[selectedArea?.id]).map(([capacity, tables]) => (
        <Item
          title={`${capacity} Person Table`}
          count={tables.length}
          isTable={true}
          onClick={() => onAddTable(parseInt(capacity))}
        />
      ))}
      {!isManagementSection && customerAreasInventory[selectedArea?.id].map((area) => (
        <Item
          title={area.name}
          count={area.count}
          isTable={false}
          onClick={() => onAddButton(area.id)}
        />
      ))}
    </Box>
  );
};

export default TableInventory;